export default "__VITE_ASSET__70671dbf__"